var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCrossRedIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.0724 2.92759C13.169 -0.975862 6.83103 -0.975862 2.92759 2.92759C-0.975862 6.83103 -0.975862 13.169 2.92759 17.0724C6.83103 20.9759 13.169 20.9759 17.0724 17.0724C20.9759 13.169 20.9759 6.83103 17.0724 2.92759ZM16.1296 3.87044C19.5126 7.25345 19.5126 12.7465 16.1296 16.1296C12.7465 19.5126 7.25345 19.5126 3.87044 16.1296C0.487431 12.7465 0.487431 7.25345 3.87044 3.87044C7.25345 0.487431 12.7465 0.487431 16.1296 3.87044ZM9.05715 10L6.45863 7.40148C6.19824 7.14143 6.19824 6.71868 6.45863 6.45863C6.71868 6.19824 7.14143 6.19824 7.40148 6.45863L10 9.05715L12.5985 6.45863C12.8586 6.19824 13.2813 6.19824 13.5414 6.45863C13.8018 6.71868 13.8018 7.14143 13.5414 7.40148L10.9429 10L13.5414 12.5985C13.8018 12.8586 13.8018 13.2813 13.5414 13.5414C13.2813 13.8018 12.8586 13.8018 12.5985 13.5414L10 10.9429L7.40148 13.5414C7.14143 13.8018 6.71868 13.8018 6.45863 13.5414C6.19824 13.2813 6.19824 12.8586 6.45863 12.5985L9.05715 10Z",
    fill: "#EE2D26"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCrossRedIcon);
export default __webpack_public_path__ + "static/media/crossRedIcon.2448d5e26849213f497e6d0151f891b5.svg";
export { ForwardRef as ReactComponent };